import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss'],
})
export class PageTitleComponent  implements OnInit {
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() backIconClass: string = ''; //clase display app/web, por default la flecha estará visible
  @Input() isMobileSearchbarActive:boolean = false;
  @Input() showTooltip:boolean = false;
  // @Input() displayMobileBackIcon:boolean = false;
  // @Input() displayWebBackIcon:boolean = false;
  @Output() backClick: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {}

  onBackClick() {
    this.backClick.emit();
  }

}
